import assign from "lodash/assign.js";
import fill from "lodash/fill.js";

export function padArray<T>(array: T[], length: number, value: T): T[] {
  return assign(fill(new Array(length), value), array);
}
